import React, { useState, useEffect } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useCommandeContext, changeValeur } from "../../contexts/CommandeContext";

export default function Quantite({ id, min, max, val }) {

	// Initialisation de l'état par défaut
	const [quantite, setQuantite] = useState('');

	let quantiteValues = [];

	for (let i = min; i <= max; ++i) {
		if (i > 0) {
			// N'affiche pas la quantité 0
			quantiteValues.push(<MenuItem key={id + '-' + i} value={i} >{i}</MenuItem>);
		}
	}

	// Recupération de la commande et du dispatcher à partir du CommandeContext
	const { dispatch } = useCommandeContext();


	useEffect(() => {
		if(val && val > 0)
			setQuantite(val);
		else if (min > 0)
			setQuantite(min);
	}, [val, min]);


	function handleChange(key, value) {
		setQuantite(value);
		dispatch(changeValeur(key, value));
	}

	return (
		<FormControl fullWidth>
			<InputLabel id="label-quantite">Quantité</InputLabel>
			<Select
				id={id}
				name={id}
				labelId="label-quantite"
				value={(val && val > 0) ? val : quantite}
				label="Quantité"
				onChange={event => { handleChange(id, event.target.value) }}
			>
				{min === 0 &&
					<MenuItem value=''><em>Aucun(e)</em></MenuItem>
				}
				{quantiteValues}

			</Select>
		</FormControl>
	);
}